import React from 'react';
import { withAppContext, ModalsContext } from '../../contexts/AppContext';

import './GlsDpm.css';

class GlsDpm extends React.Component {
    static contextType = ModalsContext;

    static mapData = {
        select_gls_pcl_shop_id: '',
        select_gls_shop_code: '',
        select_gls_pcl_shop_name: '',

        select_gls_pcl_shop_zipcode: '',
        select_gls_pcl_shop_city: '',
        select_gls_pcl_shop_address: '',
        select_gls_pcl_shop_email: '',
        select_gls_pcl_shop_phone: '',
    }

    constructor(props) {
        super(props);
        
        this.state = {
            show: true,
            scriptLoaded: false,
            selectedParcelShop: props.initialData || null,
        };

        this.appRef = props.appContext.appRef;
        this.dialogRef = React.createRef();
    }

    static handle_map_change(e)
    {
        if (!!e.detail && !!e.detail.id) 
        {
            const data = e.detail;

            // Új objektum létrehozása minden alkalommal (ne mutáljuk a statikus mapData-t)
            const newMapData = {
                select_gls_pcl_shop_id: data.id,
                select_gls_shop_code: data.id,
                select_gls_pcl_shop_name: data.name,
                select_gls_pcl_shop_zipcode: '',
                select_gls_pcl_shop_city: '',
                select_gls_pcl_shop_address: '',
                select_gls_pcl_shop_email: '',
                select_gls_pcl_shop_phone: '',
            };

            if (typeof data.contact != 'undefined') 
            {
                newMapData.select_gls_pcl_shop_zipcode = data.contact.postalCode || '';
                newMapData.select_gls_pcl_shop_city = data.contact.city || '';
                newMapData.select_gls_pcl_shop_address = data.contact.address || '';
                newMapData.select_gls_pcl_shop_email = data.contact.email || '';
                newMapData.select_gls_pcl_shop_phone = data.contact.phone || '';
            }
            
            // Frissítjük a statikus mapData-t is (kompatibilitás miatt)
            Object.assign(this.mapData, newMapData);
            
            // Frissítjük a komponens state-jét
            if (window.GlsDpmInstance) {
                window.GlsDpmInstance.setState({ selectedParcelShop: newMapData });
                
                // Ha van onSelectionChange callback, meghívjuk
                if (window.GlsDpmInstance.props.onSelectionChange) {
                    window.GlsDpmInstance.props.onSelectionChange(newMapData);
                }
            }
        }
    }

    componentDidMount() {
        window.GlsDpmInstance = this;
        this.create_web_component();
    }

    componentWillUnmount() {
        // Tisztítás
        const dialogElement = document.getElementById('gls-dpm-map');
        if (dialogElement) {
            dialogElement.removeEventListener('change', this.handleMapChange);
        }
        
        // Tisztítjuk a window referenciát is
        if (window.GlsDpmInstance === this) {
            window.GlsDpmInstance = null;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const prevShopId = prevProps.initialData?.select_gls_pcl_shop_id;
        const newShopId = this.props.initialData?.select_gls_pcl_shop_id;
        
        if (prevShopId !== newShopId) {
            this.setState({ selectedParcelShop: this.props.initialData });
        }
        
        // Ha a scriptLoaded true-ra váltott, most már feliratkozhatunk az eseményre
        if (!prevState.scriptLoaded && this.state.scriptLoaded) {
            this.setupEventListener();
        }
    }

    handleMapChange = (e) => {
        GlsDpm.handle_map_change(e);
    }

    setupEventListener = () => {
        // Várunk a custom element betöltésére és a DOM elem létezésére
        customElements.whenDefined('gls-dpm-dialog').then(() => {
            setTimeout(() => {
                const dialogElement = document.getElementById('gls-dpm-map');
                if (dialogElement) {
                    // Először eltávolítjuk ha már fel volt iratkozva (duplikáció elkerülése)
                    dialogElement.removeEventListener('change', this.handleMapChange);
                    // Újra feliratkozunk
                    dialogElement.addEventListener('change', this.handleMapChange);
                    console.log('GLS dialog event listener attached');
                } else {
                    console.warn('GLS dialog element not found');
                }
            }, 100);
        });
    }

    create_web_component() {
        if (typeof this.appRef.current.third_party['gls-dpm'] == 'undefined')
        {
            this.appRef.current.third_party['gls-dpm'] = {};
        }
    
        if (!this.appRef.current.third_party['gls-dpm'].loaded)
        {
            const script = document.createElement('script');
            script.type = 'module';
            script.src = 'https://map.gls-hungary.com/widget/gls-dpm.js';
            
            const handleScriptLoad = () => {
                this.appRef.current.third_party['gls-dpm'].loaded = true;
                
                // Várunk hogy a gls-dpm-dialog custom element betöltődjön
                customElements.whenDefined('gls-dpm-dialog').then(() => {
                    console.log('gls-dpm-dialog custom element ready');
                    
                    // setState hívása triggerelje a componentDidUpdate-et, ami meghívja a setupEventListener-t
                    this.setState({ scriptLoaded: true });
                });
            };
            
            script.addEventListener('load', handleScriptLoad);
            script.addEventListener('error', (e) => {
                console.error('GLS DPM script load error:', e);
            });

            document.head.appendChild(script);
            
            // Fallback ellenőrzés
            let checkCount = 0;
            const checkInterval = setInterval(() => {
                checkCount++;
                
                if (customElements.get('gls-dpm-dialog') || checkCount > 20) {
                    clearInterval(checkInterval);
                    if (customElements.get('gls-dpm-dialog') && !this.appRef.current.third_party['gls-dpm'].loaded) {
                        handleScriptLoad();
                    }
                }
            }, 500);
        }
        else {
            // Script már betöltődött
            // setState-tel triggereljük a render-t és a componentDidUpdate-et
            this.setState({ scriptLoaded: true }, () => {
                // Callback-ben meghívjuk a setupEventListener-t, hogy biztosan a render után fusson
                this.setupEventListener();
            });
        }
    }

    // Dialog megnyitása
    openDialog = () => {
        const dialogElement = document.getElementById('gls-dpm-map');
        console.log('Opening GLS dialog, element:', dialogElement);
        if (dialogElement && typeof dialogElement.showModal === 'function') {
            console.log('Calling showModal');
            dialogElement.showModal();
        } else {
            console.warn('showModal not available', dialogElement);
        }
    }

    // Kiválasztott csomagpont adatainak lekérése (a Form számára)
    getFormData() {
        return this.state.selectedParcelShop || {};
    }

    render() { 
        const { show, scriptLoaded, selectedParcelShop } = this.state;

        if (!show) return null; 
        
        if (!scriptLoaded) {
            return <div className="gls_chooser">Térkép betöltése...</div>;
        }
        
        return (
            <div className="gls_chooser">
                <button 
                    type="button" 
                    className="gls_select_button"
                    onClick={this.openDialog}
                >
                    {selectedParcelShop ? 'Csomagpont módosítása' : 'Csomagpont kiválasztása'}
                </button>
                
                {/* Közvetlenül a gls-dpm-dialog elemet használjuk, ahogy a PHP is csinálja */}
                {/* filter-type nélkül minden típust mutat (automaták + csomagpontok) */}
                <gls-dpm-dialog 
                    country="hu" 
                    language="hu" 
                    id="gls-dpm-map"
                />
                
                {selectedParcelShop && (
                    <div className="select_gls_pcl_shop_container">
                        <div id="show_select_gls_pcl_shop_name">{selectedParcelShop.select_gls_pcl_shop_name}</div>
                        <div id="show_select_gls_pcl_shop_address">
                            <span id="show_select_gls_pcl_shop_zipcode">{selectedParcelShop.select_gls_pcl_shop_zipcode}</span>{' '}
                            <span id="show_select_gls_pcl_shop_city">{selectedParcelShop.select_gls_pcl_shop_city}</span>
                            {selectedParcelShop.select_gls_pcl_shop_address && (
                                <>, <span id="show_select_gls_pcl_shop_address_street">{selectedParcelShop.select_gls_pcl_shop_address}</span></>
                            )}
                        </div>
                        {selectedParcelShop.select_gls_pcl_shop_phone && (
                            <div id="show_select_gls_pcl_shop_phone">{selectedParcelShop.select_gls_pcl_shop_phone}</div>
                        )}
                        {selectedParcelShop.select_gls_pcl_shop_email && (
                            <div id="show_select_gls_pcl_shop_email">{selectedParcelShop.select_gls_pcl_shop_email}</div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}
 
export default withAppContext(GlsDpm);